module.exports = __webpack_public_path__ + "static/media/ImgPlaceholder.ae20e374.png";